
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Camada_1","data-name":"Camada 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 67.39 58.58"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('circle',{staticClass:"cls-1",attrs:{"cx":"4.48","cy":"4.48","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"23.55","cy":"4.48","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"42.62","cy":"4.48","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"61.69","cy":"4.48","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"5.29","cy":"21.02","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"24.36","cy":"21.02","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"43.43","cy":"21.02","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"62.5","cy":"21.02","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"4.89","cy":"37.56","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"23.95","cy":"37.56","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"43.02","cy":"37.56","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"62.09","cy":"37.56","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"5.7","cy":"54.1","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"24.77","cy":"54.1","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"43.84","cy":"54.1","r":"4.48"}}),_c('circle',{staticClass:"cls-1",attrs:{"cx":"62.91","cy":"54.1","r":"4.48"}})])
          )
        }
      }
    